

















































































import { Component, Mixins } from "vue-property-decorator";
import { CreateElement } from "vue";
import CProdInjectorMixin from "@/mixins/cProdInjectorMixin";
import Context from "@/mixins/context";

@Component({
  components: {
    "cprod-trial-msg": () =>
      import("@/components/app/global/contractProducts/cProdTrialMsg.vue"),
    "cprod-price-tax-summary": () =>
      import(
        "@/components/app/global/contractProducts/cProdPriceTaxSummary.vue"
      )
  }
})
export default class CProdDetailsList extends Mixins(
  Context,
  CProdInjectorMixin
) {
  // Computed

  public get cProdTag() {
    if (!this.cProdData.condition) return undefined;
    const { type, summary } = this.cProdData.condition;
    return {
      render: (h: CreateElement) =>
        h("b-tag", { props: { type } }, [h(summary)])
    };
  }

  public get canViewOrder() {
    return !this.cProdData.isImported && !this.cProdData.isDelegatedAccess;
  }

  public get cProdPurchaseDate() {
    return this.$moment
      .utc(this.cProdData.contract?.created_at)
      .format(this.$t("_datetime.date.long").toString());
  }
}
